"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

var _commonUIColors = require("../../utils/commonUIColors"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'Notification'
});
schema.propTypes = {
  actions: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    onClick: _reactDesc.PropTypes.func.isRequired,
    text: _reactDesc.PropTypes.string.isRequired
  })).description('An array of objects containing a subset of props valid for the Button. Specifically excluded are `kind`, `size`, and `variant`.').isRequired,
  duration: _reactDesc.PropTypes.number.description('An integer representing the amount of milliseconds to wait until dismissing the notification if no user interaction is captured. If omitted, notification will remain until manually closed.'),
  children: _reactDesc.PropTypes.func.description('The body of the notification containing additional UI elements').format('React Component'),
  closeHint: _reactDesc.PropTypes.string.description('The text to present in the tooltip when hovering over the close button.'),
  color: _reactDesc.PropTypes.oneOf(_commonUIColors.commonUIColorKeys).description('The icon/ border color. Will override the default color associated with any specified `intent`.').format('string'),
  icon: _reactDesc.PropTypes.element.description('The `iconix` icon to display. Will override the default icon associated with any specified `intent`.').format('Iconix Icon'),
  id: _reactDesc.PropTypes.string.description('A unique identifier for the notification.'),
  intent: _reactDesc.PropTypes.oneOf(['information', 'success', 'warning', 'danger']).description('Shortcuts to the most common combinations of icon and color.'),
  onClose: _reactDesc.PropTypes.func.description('The event handler called when the notification is manually closed. Will also be called with a blank event if "DISMISS ALL" is clicked. WILL NOT be called if notification times out or is closed because an action button is clicked. In IE, will be called with an empty object.'),
  title: _reactDesc.PropTypes.string.description('The text for rendering in the H2 at the top of the notification').isRequired
};
var _default = schema;
exports.default = _default;